/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  border-radius: var(--shape-md);
  overflow: hidden;
  font-family: var(--font-sans);
  text-decoration: none;
  color: var(--md-on-surface);
  border: none;
  text-align: start;
}

/* ─── Variants ─── */

.elevated {
  background: var(--md-surface-container-lowest);
  box-shadow: var(--elevation-1);
}

.filled {
  background: var(--md-surface-container-highest);
}

.outlined {
  background: var(--md-surface);
  border: 1px solid var(--md-outline-variant);
}

/* ─── Clickable ─── */

.clickable {
  composes: focusRingOverlay from "../../shared.module.css";
  cursor: pointer;
  transition: box-shadow var(--motion-duration-short3)
    var(--motion-easing-standard);
}

@media (hover: hover) {
  .elevated.clickable:hover {
    box-shadow: var(--elevation-2);
  }

  .outlined.clickable:hover {
    box-shadow: var(--elevation-1);
  }
  .filled.clickable:hover {
    filter: brightness(0.97);
  }
}

/* ─── Media ─── */

.media {
  overflow: hidden;
  aspect-ratio: var(--card-media-ratio, auto);
}

.media > img,
.media > video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ─── Header ─── */

.header {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-6);
}

.avatar {
  flex-shrink: 0;
}

.headerText {
  flex: 1;
  min-width: 0;
}

.title {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
}

.subtitle {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  color: var(--md-on-surface-variant);
}

.headerAction {
  flex-shrink: 0;
}

/* ─── Content ─── */

.content {
  padding: 0 var(--space-6) var(--space-6);
}

.content:first-child {
  padding-block-start: var(--space-6);
}

/* ─── Actions ─── */

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-6) var(--space-6);
  margin-block-start: auto;
}
